module.exports = require("live/components/ui/SearchBar");